import { useCallback } from 'react';

import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import { useSearchParams } from 'react-router-dom';

import { RequestIssueType } from '@/rtk-query.gql';

import { ClientIssue } from './ClientIssue';
import { ISSUE_TYPES } from './constants';
import { ReportRequest } from './ReportRequest';

import './NewIssue.css';

type newProps = {
  className?: string;
};

export const NewIssuePage = ({ className }: newProps) => {
  const [params, setParams] = useSearchParams();
  const type = params.get('type');

  const handleTypeChange = useCallback(
    (e: DropdownChangeEvent) => {
      setParams((old) => {
        const params = new URLSearchParams(old);
        params.set('type', e.value);
        return params;
      });
    },
    [setParams],
  );

  if (!type) {
    return (
      <div className={`new-issue ${className || ''}`}>
        <div className="new-issue__type-picker">
          <Dropdown
            optionLabel="name"
            optionValue="id"
            options={ISSUE_TYPES}
            placeholder="Select a Type"
            value={type}
            onChange={handleTypeChange}
            autoFocus
          />
        </div>

        <div className="new-issue__form">
          <div className="new-issue__fields">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="new-issue__field">
                <label>
                  <Skeleton height="21px" width="7rem" />
                </label>
                <Skeleton height="37px" />
              </div>
            ))}
          </div>

          <div className="new-issue__description">
            <label>
              <Skeleton height="21px" width="7rem" />
            </label>
            <Skeleton height="240px" />
          </div>

          <div className="new-issue__submit">
            <Skeleton height="39px" width="100px" />
          </div>
        </div>
      </div>
    );
  }

  if (type === RequestIssueType.CLIENT) {
    return <ClientIssue />;
  }

  if (type === RequestIssueType.REPORT) {
    return (
      <>
        <ReportRequest />
      </>
    );
  }

  return null;
};
